import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmitedModalRoutingModule } from './submited-modal-routing.module';
import { SubmitedModalComponent } from './submited-modal.component';

@NgModule({
  declarations: [SubmitedModalComponent],
  imports: [CommonModule, SubmitedModalRoutingModule],
  exports: [SubmitedModalComponent],
})
export class SubmitedModalModule {}
